module.exports = function(){ /* empty */ };


/*****************
 ** WEBPACK FOOTER
 ** /home/onlygamescl/onlygames-front/shared/~/core-js/library/modules/_add-to-unscopables.js
 ** module id = 212
 ** module chunks = 1
 **/